import { BrandLogo } from '@/components/ui/BrandLogo';
import { LinkButton } from '@/components/ui/Button';
import { ROUTES } from '@/constants/routes';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

import styles from './NotFoundPage.module.css';

/** Any path no route matches. It sits outside the layouts, so it works signed in or out. */
export function NotFoundPage() {
  useDocumentTitle('Page not found');

  return (
    <div className={styles.page}>
      <BrandLogo size="md" />
      <p className={styles.code}>404</p>
      <h1 className={styles.title}>Page not found</h1>
      <p className={styles.message}>
        The page you asked for does not exist, or it has moved somewhere else.
      </p>
      <LinkButton to={ROUTES.HOME} icon="home">
        Back to home
      </LinkButton>
    </div>
  );
}
